import { searches } from '../data';

export default function SearchPills() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-6 md:flex-row md:items-center">
          <div className="shrink-0 md:w-72">
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-secondary-500">
              <i className="ri-search-line"></i>大家都在搜
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">
              今天被问得最多的话题
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              高频词即风向标，点进去就能进入对应热度场，快速找到入口。
            </p>
          </div>
          <div className="flex flex-1 flex-wrap items-center gap-2.5">
            {searches.map((word, idx) => (
              <a
                key={word}
                href="#feed"
                className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:text-[15px]"
              >
                {idx < 3 ? (
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 text-[10px] font-bold text-background-50">
                    {idx + 1}
                  </span>
                ) : (
                  <i className="ri-hashtag text-secondary-400"></i>
                )}
                <span className="whitespace-nowrap">{word}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}